import React from 'react';
import { useNavigate } from 'react-router-dom';
import './about-us.scss';

const AboutUs: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="about-us-page">

    <div className="trowel-logo"></div>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-title">About TROWEL.AI</h1>
          <p className="about-subtitle">AI-Powered Business Intelligence Platform</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="container">
          <div className="row g-4">
            {/* What We Do Card */}
            <div className="col-12 col-lg-6">
              <div className="about-card what-we-do-card">
                <div className="card-icon-wrapper">
                  <div className="card-icon-what-we-do">
                  </div>
                </div>
                <h2 className="card-title">What We Do</h2>
                <p className="card-text">
                  Trowel.AI is a cutting-edge SaaS platform that transforms complex business data into actionable insights. 
                  We leverage advanced artificial intelligence and machine learning algorithms to help businesses of all sizes 
                  make data-driven decisions, optimize operations, and accelerate growth. Our platform analyzes market trends, 
                  competitor strategies, customer behavior, and internal metrics to provide comprehensive business intelligence 
                  in real-time.
                </p>
              </div>
            </div>

            {/* Problems We Solve Card */}
            <div className="col-12 col-lg-6">
              <div className="about-card problems-card">
                <div className="card-icon-wrapper">
                  <div className="card-icon-solution">
                  </div>
                </div>
                <h2 className="card-title">Problems We Solve</h2>
                <div className="problems-list">
                  <div className="problem-item">
                    <svg className="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>
                      <h3 className="problem-title">Data Overload:</h3>
                      <p className="problem-description">Transform overwhelming business metrics into clear, actionable insights</p>
                    </div>
                  </div>
                  <div className="problem-item">
                    <svg className="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>
                      <h3 className="problem-title">Strategic Blindspots:</h3>
                      <p className="problem-description">Identify hidden opportunities and threats in your market</p>
                    </div>
                  </div>
                  <div className="problem-item">
                    <svg className="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>
                      <h3 className="problem-title">Time-Consuming Analysis:</h3>
                      <p className="problem-description">Automate research and reporting to save hundreds of hours</p>
                    </div>
                  </div>
                  <div className="problem-item">
                    <svg className="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>
                      <h3 className="problem-title">Competitive Disadvantage:</h3>
                      <p className="problem-description">Stay ahead with real-time market intelligence</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
